import { render, staticRenderFns } from "./HistoricalTrajectory.vue?vue&type=template&id=0fce6a9b&scoped=true"
import script from "./HistoricalTrajectory.vue?vue&type=script&lang=js"
export * from "./HistoricalTrajectory.vue?vue&type=script&lang=js"
import style0 from "./HistoricalTrajectory.vue?vue&type=style&index=0&id=0fce6a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce6a9b",
  null
  
)

export default component.exports